import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=709ebc79&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=709ebc79&prod&scoped=true&lang=css"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=709ebc79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709ebc79",
  null
  
)

export default component.exports